































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import DatePickerField from '@/shared/date-picker/date-picker-field.component.vue';
import TextAreaComponent from '@/shared/fields/text-area.component.vue';
import { VbLoadingService, VbSnackbarService } from 'bag-of-holding-library';
import MicrosoftService from '@/domain/microsoft/service/microsoft.service';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import MessageFilterRequest from '@/domain/microsoft/entity/message-filter.request';
import AutocompleteComponent from '@/shared/fields/autocomplete-component.vue';
import FilterEmployeeService from '@/domain/employees/service/filter-employee.service';
import UpdateAtribute from '@/domain/employees/entity/update-atribute.entity';
import CareerService from '@/domain/employees/service/career.service';
import CheckboxComponent from '@/shared/checkbox/checkbox.component.vue';
import LabelSlot from 'bag-of-holding-library/src/slot/label-slot.component.vue';
import SelectStatesComponent from '@/shared/states/select-states.component.vue';
import CountrySelect from '@/shared/country-select.component.vue';
import Country from '@/domain/countries/entity/country.entity';
import SelectCityComponent from '@/shared/city/city.component.vue';
import markdownParser from '@/shared/utils/markdown-parser';
import GenderTypes from '../employees/profile/tab-components/personal-data/gender-types.json';
import ToolbarConfig from './toolbar-config.json';

const BRA = 'BRA';

@Component({
  components: {
    MainButton,
    DatePickerField,
    TextAreaComponent,
    ModalWarning,
    AutocompleteComponent,
    CheckboxComponent,
    LabelSlot,
    SelectStatesComponent,
    CountrySelect,
    SelectCityComponent,
  },
})
export default class MessageSenderView extends Vue {
  markdown: string = '';

  videoTitle: string = '';

  videoUrl: string = '';

  openModal: boolean = false;

  filter: MessageFilterRequest = MessageFilterRequest.of({});

  filterService = new FilterEmployeeService();

  businessUnits: UpdateAtribute[] = [];

  roles: UpdateAtribute[] = [];

  workplaces: UpdateAtribute[] = [];

  resultCenters: UpdateAtribute[] = [];

  resultCenterInput = '';

  lastResultCenterFilter = '';

  filterMenu: boolean = false;

  gender: string = '';

  genderTypes = GenderTypes;

  hasChildren = false;

  notChildren = false;

  editorToolbar = ToolbarConfig;

  showForeignState: boolean = false;

  created() {
    CareerService.getRoles().then((resp: any) => this.roles = resp.data);
    CareerService.getWorkplace().then((resp: any) => this.workplaces = resp.data);
    CareerService.getBusinessUnit(true).then(resp => this.businessUnits = resp);
  }

  findResultCenter(value: string) {
    this.resultCenterInput = value;
    if ((this.lastResultCenterFilter !== value) && value) {
      this.lastResultCenterFilter = value;
      if (value.length > 2) {
        CareerService.getResultCentersByName(value)
          .then(el => this.mergeResultCenters(el));
      }
    }
  }

  mergeResultCenters(resultCenters: UpdateAtribute[]): void {
    const addedIds: string[] = this.resultCenters
      .map((resultCenter: UpdateAtribute) => resultCenter.id!!)
    resultCenters.forEach((resultCenter: UpdateAtribute) => {
      if (!addedIds.includes(resultCenter.id!!)) {
        this.resultCenters.push(resultCenter);
      }
    })
  }

  openWarningSendMessage() {
    if (!this.markdown || this.markdown.trim().length === 0) {
      VbSnackbarService.showError('Escreva uma mensagem para enviar');
      return;
    }

    if (this.videoTitle.length > 0 && this.videoUrl.length === 0) {
      VbSnackbarService.showError('Informe o link do video');
      return;
    }
    this.openModal = true;
  }

  sendMessage() {
    VbLoadingService.show();
    MicrosoftService.sendMessage({
      message: this.formatMarkdownForTeams(this.markdown),
      videoTittle: this.videoTitle,
      videoUrl: this.videoUrl,
    }, this.filter)
      .then(() => {
        VbSnackbarService.showSuccess('Solicitação enviada com sucesso');
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => VbLoadingService.hide());
  }

  formatMarkdownForTeams(markdown: string): string {
    // gera HTML usando markdown-it
    const html = markdownParser.render(markdown);

    // converte HTML para texto que o Teams aceita melhor
    return html
      .replace(/<p>/g, '')
      .replace(/<\/p>/g, '<br><br>')
      .replace(/<\/h1>/g, '</h1><hr>')
      .replace(/<\/h2>/g, '</h2><hr>')
      .trim();
  }

  closeAndSend() {
    this.closeWarningModal();
    this.sendMessage();
  }

  closeWarningModal() {
    this.openModal = false;
  }

  home() {
    this.$destroy();
    this.$router.push({
      path: '/',
    });
  }

  handleHasChidren(value: boolean) {
    this.filter.hasChildren = value || null;
    this.hasChildren = value;
  }

  handleNotChidren(value: boolean) {
    this.filter.hasChildren = value ? !value : null;
    this.notChildren = value;
  }

  updateContry(value: Country) {
    if (value.acronym !== BRA) {
      this.showForeignState = true;
      this.filter.country = value.id;
      this.filter.states = [];
      return;
    }
    this.showForeignState = false;
    this.filter.country = value.id;
    this.filter.foreignState = '';
  }

  clear() {
    this.markdown = '';
    this.videoTitle = '';
    this.videoUrl = '';
  }
}
